import React, { Component } from 'react';
import SearchBar from '../Components/SearchBar';
import { connect } from 'react-redux';
import { GetGRNDetails, GetGRNExport, getProjectAllocationByUserId } from '../store/actions/poDetailsActions';
import formatDate from '../Classes/FormatDate';
import PaginationComponent from '../Components/PaginationComponent';
import Select from "react-select";
import { GetFilterList } from '../store/actions/masterActions';
import Loading from '../Components/Loader';
import { CSVLink } from "react-csv";
import Modal from '../Components/CustomModal';
import ModalHeader from '../Components/ModalHeader';
import ModalBody from '../Components/ModalBody';
import formatDateinIst from '../Classes/FormatDateTimeInIST'
import AuthHandler from '../Classes/AuthHandler';
class GRNDataList extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            tableData: [],
            totalPos: 0,
            currentPage: new URLSearchParams(this.props.location.search).get("currentPage") ? new URLSearchParams(this.props.location.search).get("currentPage") : 1,
            posPerpage: new URLSearchParams(this.props.location.search).get("posPerpage") ? new URLSearchParams(this.props.location.search).get("posPerpage") : 10,
            searchForOptions: [
                {
                    label: 'Project No.', value: 'WBS'
                },
                {
                    label: 'PO Number', value: 'PO Number'
                },
                {
                    label: 'POLineItemSAPCode', value: 'POLineItemSAPCode'
                },
                {
                    label: 'GRN DocNO', value: 'GRN DocNO'
                },
                {
                    label: 'GRN ItemNo', value: 'GRN ItemNo'
                },
                {
                    label: 'GRNUOM ', value: 'GRNUOM'
                },
                {
                    label: 'GRN Plant ', value: 'GRNPlant'
                },
                {
                    label: 'GRNDocHeaderText ', value: 'GRNDocHeaderText'
                },
                {
                    label: 'GRNBillofLadding ', value: 'GRNBillofLadding'
                },
                {
                    label: 'ServiceLineItemNumber ', value: 'ServiceLineItemNumber'
                },
                {
                    label: 'GRNCreatedBy ', value: 'GRNCreatedBy'
                },

            ],
            searchForItem: [],
            isShowFilter: false,
            searchTerm: "",
            finalpos: [],
            finalgrndocno: [],
            finalfilterlist: [],
            filterByPOSAPId: [],
            filterByGRNDocNo: [],
            filterByGRNCreatedBy: [],
            finalgrncreatedby: [],
            finalGRNPlant: [],
            filterByGRNPlant: [],
            opacity: '',
            downloadmodal: false,
            csvData: [],
            sortByWBS: [],
            WBSCode: [],
            finalwbsno: []
        }
        // this.downloadModal = this.downloadModal.bind(this)
    }
    handleSearching = async () => {
        await this.filterData()
    }
    handleISearch = (e) => {
        let searchTerm = e.target.value
        this.setState({
            searchTerm
        })
        console.log(this.state.searchTerm)
    }
    handleSelectSearchFor = async (value) => {
        let searchFor = value
        let searchForItem = [
            {
                label: value, value: value
            }
        ]
        await this.setState({ searchFor, searchForItem })
    }
    dataSync = async () => {
        let roles = AuthHandler.getRoles()
        let userId = AuthHandler.getUserID()
        if (roles[12]) {
            let sortByWBS = []
            let WBSCode = []
            await this.props.getProjectAllocationByUserId({ UserId: userId })
            let ProjectCodes = await this.props.poDetails.getProjectAllocationByUserId
            if (ProjectCodes.length > 0) {
                ProjectCodes.map((elem) => {
                    sortByWBS.push(elem.ProjectCode)
                    WBSCode.push({ label: elem.ProjectCode, value: elem.ProjectCode })
                })
            }
            await this.setState({ sortByWBS, WBSCode })
        }
        await this.filterData(this.state.currentPage)
        await this.getFilterList()
    }
    componentDidMount = async () => {
        await this.dataSync()
    }
    handleClick = async (event) => {
        let currentPage = Number(event.target.id)
        if (!event.target.id) {
            currentPage = event.target.offsetParent.id
        }
        await this.setState({ currentPage })
        await this.filterData(currentPage)
    }
    handleSelectPoPerPage = async (event) => {
        await this.setState({ posPerpage: event.value })
        await this.filterData()
    }
    filterData = async (currentPage = 1) => {
        let searchData = {
            currentPage: currentPage,
            posPerpage: this.state.posPerpage,
            searchTerm: this.state.searchTerm,
            searchFor: this.state.searchFor,
            filterByPOSAPId: this.state.filterByPOSAPId,
            filterByGRNDocNo: this.state.filterByGRNDocNo,
            filterByGRNCreatedBy: this.state.filterByGRNCreatedBy,
            filterByGRNPlant: this.state.filterByGRNPlant,
            sortByWBS: this.state.sortByWBS
        }
        this.props.history.push({
            pathname: '/GRNDataList',
            search: "?" + new URLSearchParams(searchData).toString()
        })

        let tableData = []
        let totalPos = 0
        await this.props.GetGRNDetails(searchData)
        tableData = await this.props.poDetails.getGRNDetails.pageinfo.resultGRNData
        totalPos = await this.props.poDetails.getGRNDetails.pageinfo.totalcount
        await this.setState({ tableData, totalPos })
        console.log(tableData, "tableData")
    }
    toggleFilter = async () => {
        this.setState({ isShowFilter: !this.state.isShowFilter })
    }
    clearFilter = async () => {
        await this.setState({
            isShowFilter: false,
            currentPage: 1,
            posPerpage: 10,
            searchTerm: '',
            searchForItem: [],
            searchFor: '',
            POSAPId: [],
            GRNDocNo: [],
            GRNCreatedBy: [],
            GRNPlant: [],
            sortByWBS:[],
            WBSCode:[]
        })
        await this.filterData()
    }
    handleSelectPO = async (e) => {
        let POSAPId = []
        let filterByPOSAPId = []
        if (e.length > 0) {
            e.map((item) => {
                POSAPId.push(item)
                filterByPOSAPId.push(item.value)
            })
        }
        await this.setState({ POSAPId, filterByPOSAPId })
        await this.filterData()
    }
    handleGRNDocNo = async (e) => {

        let GRNDocNo = []
        let filterByGRNDocNo = []
        if (e.length > 0) {
            e.map((item) => {
                GRNDocNo.push(item)
                filterByGRNDocNo.push(item.value)
            })
        }
        await this.setState({ GRNDocNo, filterByGRNDocNo })
        await this.filterData()
    }
    handlegrncreatedby = async (e) => {

        let GRNCreatedBy = []
        let filterByGRNCreatedBy = []
        if (e.length > 0) {
            e.map((item) => {
                GRNCreatedBy.push(item)
                filterByGRNCreatedBy.push(item.value)
            })
        }
        await this.setState({ GRNCreatedBy, filterByGRNCreatedBy })
        await this.filterData()
    }
    handleGRNPlant = async (e) => {

        let GRNPlant = []
        let filterByGRNPlant = []
        if (e.length > 0) {
            e.map((item) => {
                GRNPlant.push(item)
                filterByGRNPlant.push(item.value)
            })
        }
        await this.setState({ GRNPlant, filterByGRNPlant })
        await this.filterData()
    }
    getFilterList = async () => {
        await this.props.GetFilterList()
        let finalfilterlist = []
        let finalpos = []
        let finalgrndocno = []
        let finalgrncreatedby = []
        let finalGRNPlant = []
        let finalwbsno = []
        await finalfilterlist.push({ label: `Open`, value: 'opened' })

        await this.props.filterList[13].map(async (item) => {
            await finalpos.push({ label: item.POSAPId, value: item.POSAPId })
        })
        await this.props.filterList[12].map(async (item) => {
            await finalgrndocno.push({ label: item.GRNDocNo, value: item.GRNDocNo })
        })
        await this.props.filterList[14].map(async (item) => {
            await finalgrncreatedby.push({ label: item.GRNCreatedBy, value: item.GRNCreatedBy })
        })
        await this.props.filterList[15].map(async (item) => {
            await finalGRNPlant.push({ label: item.GRNPlant, value: item.GRNPlant })
        })
        await this.props.filterList[2].map(async (item) => {
            await finalwbsno.push({ label: item.WBSCode, value: item.WBSCode })
        })

        await this.setState({ finalpos, finalgrndocno, finalfilterlist, finalgrncreatedby, finalGRNPlant, finalwbsno })
    }
    // loadCSVData = async () => {
    //     await this.setState({ loadingData: true })
    //     await this.props.GetGRNExport()
    //     let csvData = await this.props.poDetails.getGRNDetailsExport
    //     await this.setState({ csvData, loadingData: false, downloadmodal: true })
    // }
    downloadModal = async () => {
        await this.setState({ downloadmodal: !this.state.downloadmodal });
    }
    handleSelectWBS = async (e) => {
        let sortByWBS = []
        let WBSCode = []
        if (e.length > 0) {
            e.map((item) => {
                sortByWBS.push(item.value)
                WBSCode.push(item)
            })
        }
        await this.setState({ sortByWBS, WBSCode })
        await this.filterData()
    }
    render() {
        const { currentPage, posPerpage } = this.state;
        // const indexOfLastTodo = currentPage * posPerpage;
        // const indexOfFirstTodo = indexOfLastTodo - posPerpage;
        const filteredTodos = this.state.tableData;
        const customStyles = {
            option: (provided, state) => ({
                ...provided,
                borderBottom: '1px dotted pink',
                padding: "2px 10px",
            }),
            menu: (provided, state) => ({
                ...provided,
                width: "100%",
                minWidth: "max-content",
                zIndex: "999 !important",
            }),
        }
        if (this.props.poDetails.loading) {
            return (
                <Loading />
            )
        }
        return (
            <div className="Container-fluid p-4" style={{ marginBottom: '3%' }}>
                {this.state.loadingData == true ?
                    <div className='backdrop'>
                        <Loading />
                    </div>
                    : ""}
                {/* Download Modal Start */}
                <Modal isOpen={this.state.downloadmodal} className="modal-md">
                    <div className="modalheads">
                        <ModalHeader HeaderStyle="modal-header ">
                            <div className="modal-text"><h4>Your File Is Ready For Download</h4></div>
                            <button type="button" className="close" aria-label="Close" onClick={() => this.downloadModal()} >
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </ModalHeader>
                    </div>
                    <ModalBody Style="modal-body">
                        <div className="row" style={{ justifyContent: 'center' }}>
                            <CSVLink className="btn2 btn-sms1 rounded-pill mt-2 ml-4 float-right" data={this.state.csvData} filename={'GRN.csv'}>Download Export Data</CSVLink>
                        </div>
                    </ModalBody>
                </Modal>
                {/* Download Modal End */}
                <div className="row ">
                    <div className="col-3">
                        <div className="header"><b>GRN Data List</b></div>
                    </div>
                    <div className='col-3'>
                        {/* <button className="btn2 btn-sms1 float-right rounded-pill" style={{ marginTop: 12 }} onClick={() => this.loadCSVData()}>Export</button> */}
                    </div>
                    <div className="col-6 xs={last} pt-2" style={{ paddingRight: 30 }}>
                        <SearchBar placeholder="Search" searchClick={this.handleSearching} label="Search" ShowSearchFor={true} searchForOptions={this.state.searchForOptions} btnName="" searchForItem={this.state.searchForItem} SelectSearchForHandler={this.handleSelectSearchFor} searchInputHandler={(e) => { this.handleISearch(e) }} filter={true} clear={true} toggleFilter={this.toggleFilter} clearFilter={this.clearFilter} />
                    </div>
                </div>
                {this.state.isShowFilter ?
                    <div className="row justify-content-between pb-3 pt-3 m-0 border-radius-modal filter-data pr-2 pl-2">
                        <div className="col">
                            <Select maxMenuHeight={500} placeholder="Project No." isMulti value={this.state.WBSCode} mode="multiple" hideSelectedOptions={false} closeMenuOnSelect={false} tabSelectsValue={false} controlShouldRenderValue={false} styles={customStyles} options={this.state.finalwbsno} onChange={(e) => this.handleSelectWBS(e)} />
                        </div>
                        <div className="col">
                            <Select maxMenuHeight={500} placeholder="PO Number" isMulti value={this.state.POSAPId} mode="multiple" hideSelectedOptions={false} closeMenuOnSelect={false} tabSelectsValue={false} controlShouldRenderValue={false} styles={customStyles} options={this.state.finalpos} onChange={(e) => this.handleSelectPO(e)} />
                        </div>
                        <div className="col">
                            <Select maxMenuHeight={500} placeholder="GRN Doc No" isMulti value={this.state.GRNDocNo} mode="multiple" hideSelectedOptions={false} closeMenuOnSelect={false} tabSelectsValue={false} controlShouldRenderValue={false} styles={customStyles} options={this.state.finalgrndocno} onChange={(e) => this.handleGRNDocNo(e)} />
                        </div>
                        <div className="col">
                            <Select maxMenuHeight={500} placeholder="GRN Created By" isMulti value={this.state.GRNCreatedBy} mode="multiple" hideSelectedOptions={false} closeMenuOnSelect={false} tabSelectsValue={false} controlShouldRenderValue={false} styles={customStyles} options={this.state.finalgrncreatedby} onChange={(e) => this.handlegrncreatedby(e)} />
                        </div>
                        <div className="col">
                            <Select maxMenuHeight={500} placeholder="GRN Plant" isMulti value={this.state.GRNPlant} mode="multiple" hideSelectedOptions={false} closeMenuOnSelect={false} tabSelectsValue={false} controlShouldRenderValue={false} styles={customStyles} options={this.state.finalGRNPlant} onChange={(e) => this.handleGRNPlant(e)} />
                        </div>
                    </div>
                    : null}
                <div className="row sticky ">
                    <div className="col wrap  ">
                        <table className="table table-bordered mt-4">
                            <thead className="table sticky-inner" style={{ backgroundColor: "#0989CB", color: "white" }}>
                                <tr>
                                    <th scope="col">PO Number</th>
                                    <th scope="col" style={{ minWidth: '150px' }}>POLineItemSAPCode</th>
                                    <th scope="col">SRN</th>
                                    <th scope="col">GRN DocNO</th>
                                    <th scope="col" style={{ minWidth: '150px' }}>GRN DocYear</th>
                                    <th scope="col">GRN ItemNo.</th>
                                    <th scope="col">GRN DocDt.</th>
                                    <th scope="col" style={{ minWidth: '150px' }}>GRN PostingDt.</th>
                                    <th scope="col">GRNUOM</th>
                                    <th scope="col">GRNCreation Date</th>
                                    <th scope="col" style={{ minWidth: '150px' }}>GRNBillofLadding</th>
                                    <th scope="col" style={{ minWidth: '150px' }}>GRNDocHeader Text</th>
                                    <th scope="col" style={{ minWidth: '150px' }}>GRN Plant</th>
                                    <th scope="col" style={{ minWidth: '150px' }}>GRN CreatedBy</th>
                                    <th scope="col" style={{ minWidth: '150px' }}>Created On</th>
                                    <th scope="col" style={{ minWidth: '150px' }}>ServiceLineItem No.</th>
                                </tr>
                            </thead>
                            <tbody>
                                {
                                    this.state.tableData.map((item, index) => {
                                        return (
                                            <tr key={index}>
                                                <td>{item.POSAPId}</td>
                                                <td>{item.POLineItemSAPCode}</td>
                                                <td>{item.SRN}</td>
                                                <td>{item.GRNDocNo}</td>
                                                <td>{item.GRNDocYear}</td>
                                                <td>{item.GRNItemNo}</td>
                                                <td>{item.GRNDocDt ? formatDate(item.GRNDocDt) : '-'}</td>
                                                <td>{item.GRNPostingDt ? formatDate(item.GRNPostingDt) : '-'}</td>
                                                <td>{item.GRNQty + " " + item.GRNUOM}</td>
                                                <td>{item.GRNCreationDate ? formatDate(item.GRNCreationDate) : ''}</td>
                                                <td>{item.GRNBillofLadding}</td>
                                                <td>{item.GRNDocHeaderText}</td>
                                                <td>{item.GRNPlant}</td>
                                                <td>{item.GRNCreatedBy}</td>
                                                <td>{item.CreatedOn ? formatDate(item.CreatedOn) : '-'}</td>
                                                <td>{item.ServiceLineItemNumber}</td>
                                            </tr>
                                        )
                                    })

                                }
                            </tbody>
                        </table>
                    </div>
                </div>
                <div className="float-right">
                    <hr></hr>
                    <PaginationComponent filteredTodos={filteredTodos} currentPage={this.state.currentPage} totalPos={this.state.totalPos} handleClick={this.handleClick} handleSelectPoPerPage={this.handleSelectPoPerPage} posPerpage={posPerpage} showPosPerpage={true} />
                    <hr></hr>
                </div>
            </div>
        )
    }
}
const mapStateToProps = (state) => ({ poDetails: state.poDetails, filterList: state.masterReducer.filterList })
export default connect(mapStateToProps, { GetGRNDetails, GetFilterList, GetGRNExport, getProjectAllocationByUserId })(GRNDataList)